import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=3f4bd144&scoped=true&"
import script from "./footer.vue?vue&type=script&lang=js&"
export * from "./footer.vue?vue&type=script&lang=js&"
import style0 from "./footer.vue?vue&type=style&index=0&id=3f4bd144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4bd144",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiTransition: require('/app/components/ui/transition.vue').default,UiSocials: require('/app/components/ui/socials.vue').default})
